import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const predictAuctionPrice = async (payload, context = {}) => {
  if (!payload) {
    return {
      status: 'error',
      error: 'Payload requerido para predecir precio de subasta',
    };
  }

  try {
    const predictAuctionPriceFn = httpsCallable(functions, 'predictAuctionPriceV2');
    const result = await predictAuctionPriceFn({
      ...payload,
      operatingUnitId: context.activeUnitId ?? context.operatingUnitId,
      dealershipId: context.dealershipId ?? context.dealership,
      requestedApp: 'dealership_web',
    });
    return result.data;
  } catch (error) {
    console.error('Error obteniendo recomendacion de precios:', error);
    notifyPermissionDenied(error);
    return {
      status: 'error',
      error: error.message || 'No se pudo obtener recomendacion de precios',
    };
  }
};
